import React, {FC, PropsWithChildren} from 'react';
import styled, {css} from 'styled-components';

/*
 * Props.
 */

interface StyledToolbarBorderDivProps {
  $hasSynchronousTimeline?: boolean;
}

interface BaseComposerToolbarProps
  extends PropsWithChildren<{
    hasSynchronousTimeline: boolean;
    hideTopBorder?: boolean;
  }> {}

/*
 * Style.
 */

const StyledToolbarDiv = styled.div`
  flex-shrink: 0;

  display: flex;
  padding: 10px 7px;

  background-color: ${(p) => p.theme.message.background};
  border-radius: 0 0 16px 16px;
`;

const StyledToolbarBorderDiv = styled.div<StyledToolbarBorderDivProps>`
  ${(p) =>
    p.$hasSynchronousTimeline
      ? css`
          border-top: 1px solid ${p.theme.message.border};
          margin: 0px 10px;
        `
      : css`
          border-top: 1px solid ${p.theme.message.border};
        `}
`;

/*
 * Component.
 */

export const BaseComposerToolbar: FC<BaseComposerToolbarProps> = (props) => (
  <>
    {!props.hideTopBorder && (
      <StyledToolbarBorderDiv $hasSynchronousTimeline={props.hasSynchronousTimeline} />
    )}
    <StyledToolbarDiv>{props.children}</StyledToolbarDiv>
  </>
);
